<template>
    <div id="panel-paymentdelivery" class="panel">
        <div class="panel-hdr bg-primary-700 bg-success-gradient">
            <h2>
                Умови оплати і постачання
            </h2>
            <div class="panel-toolbar">
                <button class="btn btn-panel waves-effect waves-themed" data-action="panel-collapse" data-toggle="tooltip" data-offset="0,10" data-original-title="Collapse"></button>
                <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen" data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen"></button>
            </div>
        </div>
        <div class="panel-container collapse show overflow-auto">
            
            <div class="panel-content">
                <div class="pay_standart">
                    <div class="row bottom5">
                        <div class="col-sm-12">
                            <b>Оплата:</b> {{tender?.payment?.title}}
                        </div>
                    </div>
                    
                    <div class="row bottom5">
                        <div class="col-sm-12">
                            <b>Постачання:</b> {{tender?.delivery?.title}}</div>
                    </div>
                    
                    <div class="row bottom5">
                        <div class="col-sm-12">
                            <b>Дата постачання:</b> {{tender?.date_delivery}}</div>
                    </div>
                </div>
            
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "tender_payment",
    props : {
        tender : {
            type : Object,
            required : true
        }
    },
   
}
</script>


<style scoped>

</style>